<template>
    <b-container
        :fluid="isDesktop"
        :class="{ 'h-100': !isDesktop }"
        :style="[ !isDesktop ? { 'overflow-x': 'hidden', 'overflow-y': 'scroll' } : { 'height': '98%' } ]">
        <!-- Home: Desktop -->
        <template v-if="isLoaded && isDesktop">
            <home-desktop-coach v-if="hasRoleCoach" />
            <home-desktop-relais v-else-if="hasRoleRelais" />
            <home-desktop-worker v-else-if="hasRoleWorker" />
        </template>

        <!-- Home: Mobile -->
        <template v-else-if="isLoaded">
            <home-mobile-coach v-if="hasRoleCoach" />
            <home-mobile-relais v-else-if="hasRoleRelais" />
            <home-mobile-worker v-else-if="hasRoleWorker" />
            <survey-popup v-if="!isDesktop"/>
        </template>

        <!-- Didacticial -->
        <Didacticial
            :didacticial="didacticial"
            @close="clearDidacticial()"
        />
    </b-container>
</template>

<script>
    import TimelineContainer from '../components/TimelineContainer'
    import NotificationContainer from '../components/NotificationContainer'
    import AeBlock from '../components/Block'
    import HomePlaceholder from '../components/home/Placeholder'
    import SurveyPopup from "../components/survey/Popup"
    import CoachTodo from "../components/CoachTodo"
    import HomeDesktopRelais from "../components/home/desktop/Relais"
    import HomeTopCoach from "../components/home/top/Coach"
    import HomeMiddleMeeting from "../components/home/middle/Meeting"
    import HomeMiddleNews from "../components/home/middle/News"
    import HomeBottomReminder from "../components/home/bottom/Reminder"
    import HomeTopWorker from "../components/home/top/Worker"
    import HomeMiddleMeetingType from "../components/home/middle/MeetingType"
    import HomeBottomMeeting from "../components/home/bottom/Meeting"
    import HomeDesktopCoach from "../components/home/desktop/Coach"
    import HomeMobileCoach from "../components/home/mobile/Coach"
    import HomeMobileRelais from "../components/home/mobile/Relais"
    import HomeMobileWorker from "../components/home/mobile/Worker"
    import HomeDesktopWorker from "../components/home/desktop/Worker"
    import Didacticial from '@/components/Didacticial'

    export default {
        name: 'home',
        components: {
            HomeDesktopWorker,
            HomeMobileWorker,
            HomeMobileRelais,
            HomeMobileCoach,
            HomeDesktopCoach,
            HomeBottomMeeting,
            HomeMiddleMeetingType,
            HomeTopWorker,
            HomeBottomReminder,
            HomeMiddleNews,
            HomeMiddleMeeting,
            HomeTopCoach,
            HomeDesktopRelais,
            CoachTodo,
            SurveyPopup,
            HomePlaceholder,
            AeBlock,
            NotificationContainer,
            TimelineContainer,
            Didacticial
        },
        async mounted() {
            this.update()
                .then(() => this.isLoaded = true)
                .catch(console.error)

            if (this.didacticialId !== null) {
                await this.$store.dispatch('base/didacticial/all')
                const target = this.$store.state.base.didacticial.list.find(item => item.id == this.didacticialId)
                if (target !== null) this.didacticial = target
                this.$nextTick(() => {
                    if (!this.$refs.modal) return
                    this.$refs.modal.show()
                })
            }
        },
        data: function() {
            return {
                isLoaded: false,
                windowInnerWidth: window.innerWidth,
                isDesktop: window.innerWidth > 768,
                didacticialId: window.sessionStorage.getItem('didacticial_id'),
                didacticial: null
            }
        },
        computed: {
            home() {
                return this.$store.state.base.appInterface.home
            },
            user() {
                return this.$store.state.base.account.information
            },
            hasRoleWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            hasRoleCoach() {
                if (!this.user) return false
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            hasRoleRelais() {
                return this.$store.getters['base/account/getIsWorkerRelais'](this.user)
            },
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
        },
        methods: {
            async update() {
                await this.$store.dispatch('base/appInterface/home')
            },
            actuality(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'actuality'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            clearDidacticial() {
                this.didacticial = null
                this.didacticialId = null
                window.sessionStorage.removeItem('didacticial_id')
            }
        }
    }
</script>
